import { Subscription } from 'rxjs/Subscription';
//Angular
import {
    Component, OnInit, ViewContainerRef, Input,
    Compiler, Inject, OnDestroy
} from "@angular/core";

//Services
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { TrustpilotService } from "../../../services/cms/trustpilot.service";

@Component({
    selector: "trustpilot-widget",
    template: ""
})

export class TrustpilotWidgetComponent implements OnInit, OnDestroy {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            @Inject('isBrowser') private isBrowser: boolean,
            private trustpilotService: TrustpilotService
        ) { }


    private sub = new Subscription();
    @Input() trustpilotType: string;

    ngOnInit() {
        if (!this.trustpilotType)
            this.trustpilotType = 'default';

        let trustpilotSub = this.trustpilotService.getTrustpilotData(this.trustpilotType).subscribe(result => {
            //-- If result is null, it means that trustpilot with given type doesn't exist, or trustpilot module is not active
            let subComponent = this.createSubComponent(result);
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        })

        this.sub.add(trustpilotSub);
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private createSubComponent(trustpilotData: any) {

        //-- If trustpilot module is not active, we are going to set a template to empty string 
        @Component({
            template: trustpilotData.TemplateHtml || ""
        })

        class ChildComponent implements OnInit {

            constructor
                (
                    @Inject('isBrowser') private isBrowser: boolean,
            ) { }

            private pageIsInit: boolean = false;

            ngOnInit() {
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Initializing trustbox
                const trustboxesRef = Array.from(document.querySelectorAll('.trustpilot-widget'));
                //-- Initialize all trustbox instances on the page
                if (trustboxesRef && trustboxesRef.length > 0)
                    trustboxesRef.forEach(singleTrustboxInstance => Trustpilot.loadFromElement(singleTrustboxInstance));

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/core/widget/trustpilot-widget.component.ts